<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <router-link to="/forgot-password" class="ms-0 ps-0 login-highlight back-btn-pwd">Back</router-link>
            <div class="rep-icon-login">
              <img
              src="../../assets/images/member-login.svg"
              alt="image-fluid"
              />
            </div>
            <h4 class="login-title mb-2">Send OTP</h4>
            <div class="auth-form pt-3 pb-3">
              <div class="verify-option mb-3" @click="option = 'phone'">
              <div>
                <label class="custom-radio">
                  <input type="radio" name="custom-radio" value="phone" v-model="option" />
                  <span class="radiomark"></span>
                </label>
              </div>
              <div>Mobile ({{ verifyIdentityInfo.phone }})</div>
            </div>

            <div class="verify-option mb-3" @click="option = 'email'">
              <div>
                <label class="custom-radio">
                  <input type="radio" name="custom-radio" value="email" v-model="option" />
                  <span class="radiomark"></span>
                </label>
              </div>
              <div>Email ({{ verifyIdentityInfo.email }})</div>
            </div>

            <div class="verify-option mb-3" @click="option = 'both'">
              <div>
                <label class="custom-radio">
                  <input type="radio" name="custom-radio" value="both" v-model="option" />
                  <span class="radiomark"></span>
                </label>
              </div>
              <div>Email & Mobile</div>
            </div>
              <div>
                <button
                  class="submit-btn mt-3 next-btn"
                  type="button"
                  @click="sendOTP"
                  :disabled="otpLoader"
                >
                  <b-spinner v-if="otpLoader" small class="mr-3"></b-spinner>
                  Send Verification Code
                </button>
              </div>
            </div>
            <!-- <submit-issue /> -->
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding">
          <Logincarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logincarsoule from "./Logincarsoule";
import Api from "@/resource/MemberApi";
import helper from "@/resource/Helper";
// import SubmitIssue from "./SubmitIssue";
export default {
  name: "VerifyIdentity",
  data () {
    return {
      option: '',
      selectedVerifyIdentity: '',
      otpLoader: false,
      verifiedIdentitySelectedInfo: {}
    }
  },
  components: {
    Logincarsoule,
    // SubmitIssue
  },
  computed: {
    verifyIdentityInfo () {
      return this.$store.getters.memberInfoVerifyIdentity
    }
  },
  mounted() {
    let app = this
    app.setDefaultVerifyIdentity()
    this.option = "email";
    let deviceId = this.$store.getters.deviceId;
    if (!deviceId) {
      deviceId = this.$uuid.v1();
      this.$store.commit("setDeviceId", deviceId);
    }
  },
  methods: {
    setDefaultVerifyIdentity () {
      let app = this
      app.selectedVerifyIdentity = this.$store.getters.memberInfoVerifyIdentity.email
    },
    sendOTP() {
      let app = this;
      app.otpLoader = true;
      app.$store.commit("setAuthentication", false);

      const device_id = app.$store.getters.deviceId;
      const email = app.verifyIdentityInfo.email; // getting email from the store
      const type = app.option; // phone/email/both

      const payload = {
        email: email,
        device_id: device_id,
        type: type
      };

      app.verifiedIdentitySelectedInfo = payload;
      app.$store.dispatch("verifiedIdentitySelectedInfo", payload);

      Api.post("v4/auth/reset-generate-otp", payload)
        .then(function (response) {
          if (response.data.status === "success") {
            app.otpLoader = false;
            app.$router.push("/verify-otp");
            helper.infoMessage(app, response.data.status, response.data.message);
          }
        })
        .catch(function (error) {
          app.otpLoader = false;
          if (error.response?.data?.status === "error") {
            helper.infoMessage(app, error.response.data.status, error.response.data.message);
          }
        });
    }

  },
  watch: {
    selectedVerifyIdentity(newVal) {
      let app = this
      app.option = newVal === app.verifyIdentityInfo.phone ? 'phone' : 'email';
    }
  }
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
/* .rep-icon-login img {
  width: 100px;
} */
.back-btn-pwd:hover{
    color: #00CCFE !important;
  }

  .verify-option {
  cursor: pointer;
}

.custom-radio {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
}

.custom-radio input[type="radio"] {
  cursor: pointer;
  margin-right: 8px;
}
</style>
  
    